import { toast } from "sonner";
import { nomeDoMes } from "@bookdental/schemas";
import { trpc } from "@/lib/trpc";
import { reais } from "@/lib/dinheiro";
import { cn } from "@/lib/cn";

/** As importações feitas, com o que entrou e o "Desfazer" (só com todos os meses abertos). */
export function ListaDeImportacoes() {
  const utils = trpc.useUtils();
  const lista = trpc.financeiro.importacao.listar.useQuery().data ?? [];
  const desfazer = trpc.financeiro.importacao.desfazer.useMutation({
    onSuccess: (r) => {
      toast.success(`Importação desfeita: ${r.apagados} lançamentos apagados.`);
      utils.financeiro.invalidate();
    },
    onError: (e) => toast.error(e.message),
  });
  if (!lista.length) return null;
  return (
    <div>
      <p className="mb-1.5 text-xs font-semibold uppercase tracking-wide text-zinc-500 dark:text-muted-foreground">Importações</p>
      <ul className="divide-y divide-zinc-100 rounded-lg border border-zinc-200 dark:divide-border/50 dark:border-border">
        {lista.map((i) => (
          <li key={i.id} className={cn("flex flex-wrap items-center gap-x-4 gap-y-1 px-3 py-2 text-sm", i.desfeitaEm && "opacity-50")}>
            <div className="min-w-0 flex-1">
              <p className="truncate font-medium text-zinc-900 dark:text-foreground">{i.arquivo}</p>
              <p className="text-[11px] text-zinc-500 dark:text-muted-foreground">
                {new Date(i.criadoEm).toLocaleDateString("pt-BR")} · {i.quantidade} lançamentos
                {i.de && ` · ${nomeDoMes(i.de)}${i.ate && i.ate !== i.de ? ` a ${nomeDoMes(i.ate)}` : ""}`}
                {i.desfeitaEm ? " · desfeita" : ` · entradas ${reais(i.entradasCents)}, saídas ${reais(i.saidasCents)}`}
              </p>
            </div>
            {i.podeDesfazer && (
              <button
                type="button"
                disabled={desfazer.isPending}
                onClick={() => window.confirm(`Desfazer a importação de ${i.arquivo}? Os ${i.quantidade} lançamentos dela serão apagados.`) && desfazer.mutate({ id: i.id })}
                className="text-xs font-semibold text-red-600 hover:underline"
              >
                Desfazer
              </button>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
